export default __webpack_public_path__ + "files/media/plane.b911406a.jpg";